import { useState } from 'react';
import { unique } from 'radash';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';
import { Check } from './Check';
import { Button } from './Button';
import { colors } from '../../constants';
import { SelectShared } from './SelectShared';

export const MultiSelect = ({ choices, value, onChange, label, help }) => {
  const [open, setOpen] = useState();

  const value_ = value || [];

  const update = (field, v) => {
    if (!v) {
      onChange(value_.filter((it) => it != field));
    } else {
      onChange(unique([...value_, field]));
    }
  };

  const optionNodes = choices.map(([field, label]) => {
    return (
      <div key={field}>
        <Check size="sm" value={value_.includes(field)} onChange={(v) => update(field, v)}>
          {label || field}
        </Check>
      </div>
    );
  });

  const selectorNode = ({ onClose }) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {optionNodes}
      <Button grayFlat onClick={onClose}>
        Done
      </Button>
    </div>
  );

  const selected = choices.filter(([field, label]) => value_.includes(field));
  const nodes = selected.map(([field, label], idx) => {
    if (!value_.includes(field)) {
      return null;
    }
    return (
      <div key={field}>
        {label || field}
        {idx < selected.length - 1 && ','}
      </div>
    );
  });

  return <SelectShared display={nodes} selector={selectorNode} label={label} help={help} />;
};
